/* ══════════════════════════════════════════════════════════════════════════
 * TERMS · PRIVACY · COOKIES INSIDE THE APP — Al-Noor, 14 Oct 2026
 *
 * The app's footer sent people out to the website, "down a rabbit hole", and
 * he asked for the bare minimum. Apps (Uber Eats, OpenTable, DoorDash) carry no
 * footer; the legal documents sit in Settings and open as the app's own screen
 * with a back arrow. The words are the documents themselves, read from the
 * same .txt the website shows (GET /legal/<doc>.json, legal.js) — never a
 * second copy.
 * ══════════════════════════════════════════════════════════════════════════ */
import { useEffect, useState } from 'react';
import { call } from './api.js';
import { TabBar } from './ui.jsx';
import { goBack } from './nav.js';

const DOCS = ['privacy', 'terms', 'cookies'];

export default function Legal() {
  const key = new URLSearchParams(window.location.search).get('legal');
  const [doc, setDoc] = useState(null);
  const [err, setErr] = useState('');
  useEffect(() => {
    if (!DOCS.includes(key)) { setErr('This page does not exist.'); return undefined; }
    let live = true;
    call(`/legal/${key}.json`).then((d) => { if (live) setDoc(d); }).catch((e) => { if (live) setErr(e.message); });
    return () => { live = false; };
  }, [key]);
  return (
    <div className="home legal">
      <div className="top">
        <a className="back" href="?settings=1" aria-label="Back"
          onClick={(e) => { e.preventDefault(); goBack('?settings=1'); }}>‹</a>
        <h1 className="heroline">{doc ? doc.title : ''}</h1>
      </div>
      <main>
        {err && <div className="err" aria-live="polite">{err}</div>}
        {!doc && !err && <p className="mut">Loading…</p>}
        {doc && (
          <>
            {/* ⚠️ NO VERSION / EFFECTIVE DATE / APPLIES-TO LINES IN THE APP —
                Al-Noor, 21 Oct 2026: "get rid of it". They stay in the legal
                files and on the website; the Eleater reads the policy. */}
            <div className="legaltext" dangerouslySetInnerHTML={{ __html: doc.html }} />
          </>
        )}
      </main>
      <TabBar active="profile" />
    </div>
  );
}
